// PARTNER_ADRESA_V1 (21. 10. 2026): JEDEN blok adresy v bunkách (0.J) — rovnako ako karta zamestnanca: „… — ulica a číslo“ a „PSČ, obec a štát“.
// hodnota = objekt s bunkami adresa_* (môže to byť celý formulár), zmen(bunky) dostane všetkých päť buniek naraz.
// Jeden riadok adresy pre doklady poskladá adresaSloz (lib/adresa.js) — formulár ho drží v svojom poli (address, adresa, site_address).
// ADRESA_BUNKY_V1 (27. 10. 2026): ten istý blok aj v karte zamestnanca a v Novej / Upraviť zákazke (0.J) —
//   rozlozenie 'bunky' = dva samostatné prvky do mriežky formulára (karta zamestnanca: dva stĺpce vedľa seba), 'stlpec' = pod sebou (predvolené);
//   povinne = hviezdička pri obci; tituly = { adresa_ulica: 'bublina …' }; každé pole nesie data-pole, aby formulár skočil kurzorom na chybnú bunku.
import React from 'react'
import { COLORS, TYPO, SPACE, RADIUS } from '../theme.js'
import { Input } from './Input.jsx'
import { ADRESA_CASTI } from '../lib/adresa.js'

// riadok = jeden riadok, ktorý pôjde na doklady (ukáže sa pod bunkami, mockup 21. 10. „toto je ok“); poznamka = drobný text pod blokom
export default function AdresaBunky({ hodnota, zmen, nadpis = 'Adresa', disabled = false, labelStyle = null, inputStyle = null, style = null, riadok, poznamka,
  rozlozenie = 'stlpec', povinne = false, tituly = null }) {
  const v = hodnota || {}
  const nastav = (k, x) => { const o = {}; ADRESA_CASTI.forEach(c => { o[c] = v[c] == null ? '' : v[c] }); o[k] = x; zmen(o) }
  const lab = labelStyle || { fontSize: TYPO.sizes.sm, fontWeight: TYPO.weights.semibold, color: COLORS.text, marginBottom: 4 }
  const pole = (k, flex, placeholder, extra = {}) => (
    <Input value={v[k] == null ? '' : v[k]} onChange={x => nastav(k, x)} placeholder={placeholder} disabled={disabled} data-pole={k}
      title={(tituly && tituly[k]) || undefined}
      style={{ flex: flex + ' 1 0', minWidth: 0 }} inputStyle={{ width: '100%', ...(inputStyle || {}) }} {...extra} />
  )
  const ulica = (<>
    <div style={lab}>{nadpis} — ulica a číslo</div>
    <div style={{ display: 'flex', gap: SPACE.xs, marginBottom: rozlozenie === 'bunky' ? 0 : SPACE.sm }}>
      {pole('adresa_ulica', 3, 'ulica (v obci bez ulíc názov obce)')}
      {pole('adresa_cislo', 1, 'číslo')}
    </div>
  </>)
  const obec = (<>
    <div style={lab}>PSČ, obec a štát{povinne ? <b style={{ color: COLORS.remove }}> *</b> : null}</div>
    <div style={{ display: 'flex', gap: SPACE.xs }}>
      {pole('adresa_psc', 1, 'PSČ', { inputMode: 'numeric' })}
      {pole('adresa_obec', 2, 'obec / mesto')}
      {pole('adresa_stat', 1, 'štát')}
    </div>
  </>)
  const doplnok = (<>
    {riadok !== undefined && (<>
      <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginTop: SPACE.sm }}>Riadok na doklady:</div>
      <div style={{ fontFamily: TYPO.mono, fontSize: TYPO.sizes.sm, background: COLORS.bgSoft, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md, padding: '8px 10px', marginTop: 4 }}>{riadok || '—'}</div>
    </>)}
    {poznamka && <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginTop: 4, lineHeight: 1.5 }}>{poznamka}</div>}
  </>)
  if (rozlozenie === 'bunky') return (<><div>{ulica}</div><div>{obec}{doplnok}</div></>)   // ADRESA_BUNKY_V1: dve bunky mriežky
  return (
    <div style={style || undefined}>
      {ulica}
      {obec}
      {doplnok}
    </div>
  )
}
